<mat-accordion *ngIf="currentModule">
    <div class="nav-drawer-profile-container">
        <app-tenant-switcher [tenant]="tenant" [accessibleTenants]="accessibleTenants"
            (switchTenant$)="tenantSelected($event)"></app-tenant-switcher>
        <div class="flex-spacer"></div>
        <app-notifications>
            <div class="flex-spacer"></div>
            <button mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </app-notifications>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>manage_accounts</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <div class="icon-with-text clickable padded-menu-option" *ngIf="profileModule"
                (click)="processChildClick($event, {link: 'me'}, profileModule)" type="button">
                <mat-icon>person</mat-icon>
                <span>{{ '@profile' | translate}}</span>
            </div>
            <div class="icon-with-text clickable padded-menu-option" *ngIf="notificationModule"
                (click)="processChildClick($event, {link: 'notificationPreferences'}, profileModule)">
                <mat-icon>notifications</mat-icon>
                <span>{{ '@notificationPreferences' | translate}}</span>
            </div>
            <app-language-picker mode="menu"></app-language-picker>
            <div class="icon-with-text clickable padded-menu-option" href="#" (click)="logoutClicked($event)">
                <mat-icon>logout</mat-icon>
                <span>{{ '@logout' | translate}}</span>
            </div>
        </mat-menu>
    </div>
    <ng-container *ngFor="let item of headerItems">
        <mat-expansion-panel *ngIf="hasChildren(item); else flatModule"
                             [expanded]="item.name === currentModule.name">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <!--module name-->
                    {{item.name | translate}}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <!--child modules-->
            <div *ngFor="let child of item.childModules" (click)="processChildClick($event, child, item)"
                [ngClass]="{ hidden: child?.class === 'hide', 'selected': child?.name === currentChildModule?.name}"
                class="padded-side-nav-module clickable">
                <i class="{{child?.class}}"></i>&nbsp;
                {{ child?.name | translate }}
            </div>
        </mat-expansion-panel>

        <!-- disabled panel keeps the accordion chrome; header click still navigates (null child = module root). -->
        <ng-template #flatModule>
            <mat-expansion-panel hideToggle disabled
                                 class="nav-drawer-flat-module"
                                 [ngClass]="{ 'flat-selected': item.name === currentModule.name }">
                <mat-expansion-panel-header (click)="processChildClick($event, null, item)">
                    <mat-panel-title>
                        {{ item.name | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
        </ng-template>
    </ng-container>
    <mat-expansion-panel *ngIf="configModule && configGroups.length" [expanded]="configActive"
                         data-id="drawerConfigPanel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ configModule.name | translate }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="padded-side-nav-module clickable" data-id="drawerConfigOverview"
            [ngClass]="{ selected: configActive && !activeSectionKey }"
            (click)="processChildClick($event, null, configModule)">
            <mat-icon class="drawer-config-icon">{{ configOverview.icon }}</mat-icon>&nbsp;
            {{ configOverview.labelKey | translate }}
        </div>
        <ng-container *ngFor="let entry of configGroups">
            <div class="drawer-config-group">{{ entry.group.labelKey | translate }}</div>
            <div class="padded-side-nav-module clickable" *ngFor="let section of entry.sections"
                [attr.data-id]="section.key + 'DrawerItem'"
                [ngClass]="{ selected: section.key === activeSectionKey }"
                (click)="configSectionClick($event, section)">
                <mat-icon class="drawer-config-icon">{{ section.icon }}</mat-icon>&nbsp;
                {{ section.labelKey | translate }}
            </div>
        </ng-container>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="thirdPartyApps.length" data-id="drawerLinksPanel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ '@links' | translate }}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="padded-side-nav-module clickable" *ngFor="let app of thirdPartyApps"
            [attr.data-id]="app.key + 'DrawerLink'" (click)="launchThirdPartyApp($event, app)">
            {{ app.labelKey | translate }}
        </div>
    </mat-expansion-panel>
</mat-accordion>